import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { WithApp } from 'contexts/appContext';

// Import Components
import Card from 'components/Card/Card.js';
import CardHeader from 'components/Card/CardHeader.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardBody from 'components/Card/CardBody.js';
import Button from 'components/CustomButtons/Button.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import SweetAlert from 'react-bootstrap-sweetalert';

// @material-ui/icons
import { Dashboard } from '@material-ui/icons';

import styles from 'assets/jss/material-dashboard-pro-react/views/regularFormsStyle';
import { TextField } from '@material-ui/core';
import { AllowedGuard } from '../../../Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import ModalFull from 'components/Tvendo/Common/ModalFull';
import { wsCreate, wsUrl } from 'services/WService';
import { currency } from 'hooks/Pipe';

const useStyles = makeStyles((theme) => ({
  ...styles,
  root: {
    flexGrow: 1,
    width: '100%',
    backgroundColor: theme.palette.background.paper
  },
  cardIconTitle: {
    color: 'black',
    fontWeight: 'bold'
  },
  contButtonHeader: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  paper: {
    padding: theme.spacing(2),
    '& h6': {
      fontSize: 13,
      fontWeight: 'bold'
    },
    '& h5': {
      fontSize: 15,
      fontWeight: 400
    },
    marginBottom: '10px'
  },
  input: {
    '& input': {
      textAlign: 'right'
    }
  }
}));

const columnsHC = [
  { Header: '#', accessor: 'num', width: 80 },
  { Header: 'Cod. Prod.', accessor: 'codArticle', width: 120 },
  { Header: 'Nombre producto', accessor: 'article' },
  { Header: "Paq.'s", accessor: 'packs', width: 100 },
  { Header: "Unid.'s", accessor: 'unities', width: 150 },
  { Header: "Despa.'s", accessor: 'entry', width: 110 },
  { Header: 'Dev. Docs.', accessor: 'returns', width: 180 },
  /* { Header: 'Dev. Físicos', accessor: 'physic_quantity_returned', width: 130 }, */
  { Header: 'Diferencia', accessor: 'diferents', width: 100 },
  { Header: 'Valorizado', accessor: 'difference_amount', width: 105 },
  { Header: '', accessor: 'actions', width: 0 }
];

export default WithApp(function DistributionTracking(props) {
  const classes = useStyles();
  const [idHR, setIdHR] = useState({});

  const {
    setStateDifferences,
    stateDifferences,
    dataDetail,
    dataHR,
    reload,
    reloadDoc,
    reloadHC,
    showNotify,
    confirmAlert
  } = props;
  const [open, setOpen] = useState(false);

  const [listHC, setListHC] = useState([]);

  const handleChangeRow = (field, value, id) => {
    let cloneRows = [...listHC];
    if (id !== undefined) {
      let objIndex = cloneRows.findIndex((obj) => obj.id == id);
      cloneRows[objIndex][field] = value;
      setListHC([...cloneRows]);
    }
  };

  async function savePartial(idHR, dataCommodity) {
    let arr = dataCommodity
      .filter((obj) => obj.difference != '' && obj.difference != null)
      .map((item) => {
        return {
          id: item.id,
          /* physic_quantity_returned: item.physic_quantity_returned, */
          difference: item.difference
        };
      });

    if (arr.length < 1) {
      showNotify('No hay modificaciones en la columna diferencias', 'info');
      return;
    }

    let response = await wsCreate(`prog/sheet-distribution/${idHR}/set-returned-quantity`, {
      loads: arr
    });

    if (response.success) {
      showNotify(response.message);
      // Recargar DATA
      setStateDifferences('N');
      reloadData();
    } else {
      showNotify(response.message, 'error');
    }
  }

  async function closeDifferences() {
    let response = await wsCreate('prog/sheet-distribution/' + idHR + '/close-differences');
    if (response.success) {
      setStateDifferences('Y'); // Cambio de estado local de diferencias a Cerrado
      reloadData();
    } else {
      showNotify(response.message, 'error');
    }
  }

  function reloadData() {
    reload();
    reloadDoc(idHR);
    reloadHC(idHR);
  }

  const showCommodity = () => {
    let urlPdfComodity = wsUrl(`prog/sheet-distribution/${idHR}/sheet-load-returned`);
    return urlPdfComodity;
  };

  useEffect(() => {
    setListHC(dataDetail);
    setIdHR(dataHR.id);
  }, [dataDetail]);

  return (
    <>
      <ModalFull title="Hoja de mercadería" open={open} setOpen={setOpen} iframe>
        <iframe src={open ? showCommodity() : undefined} width="100%" height="100%">
          No se pudo cargar el contenido.
        </iframe>
      </ModalFull>
      <Card>
        <CardHeader icon>
          <CardIcon color="primary">
            <Dashboard />
          </CardIcon>
          <span className={classes.contButtonHeader}>
            <h4 className={classes.cardIconTitle}>Hojas de carga</h4>
            <div style={{ marginTop: '15px' }}>
              <AllowedGuard
                permission={ConstantPermissions.PROG_SHEET_DISTRIBUTIONS_LIQUIDATION_COMMODITY_SAVE}
              >
                <Button
                  color={props.themeContext.buttonColorSuccess}
                  round
                  size="sm"
                  onClick={() => savePartial(idHR, listHC)}
                  disabled={
                    stateDifferences != 'Y' && ['L', '5'].includes(dataHR.state) ? false : true
                  }
                >
                  Guardar
                </Button>
                <Button
                  color={props.themeContext.buttonColor}
                  round
                  size="sm"
                  onClick={() => setOpen(true)}
                >
                  Ver mercadería
                </Button>
              </AllowedGuard>
              <AllowedGuard
                permission={
                  ConstantPermissions.PROG_SHEET_DISTRIBUTIONS_LIQUIDATION_LEFT_OVERS_PRINT
                }
              >
                <Button
                  color="danger"
                  round
                  size="sm"
                  onClick={() => confirmAlert(closeDifferences, false)}
                  disabled={stateDifferences == 'Y' || !['L', '5'].includes(dataHR.state)}
                >
                  Cerrar diferencias
                </Button>
              </AllowedGuard>
            </div>
          </span>
        </CardHeader>
        <CardBody>
          <ReactTable
            exportExcel={
              stateDifferences != 'Y' && ['L', '5'].includes(dataHR.state) ? false : true
            }
            excelName="Hojas-de-carga"
            indexColumn={[3, 4, 5, 6, 7, 8, 9]}
            alignColumn={['right', 'right', 'right', 'right', 'right', 'right', 'right']}
            defaultWidth={1400}
            columns={columnsHC}
            data={listHC.map((bCommodity, i) => {
              let canUpdate =
                stateDifferences != 'Y' && ['L', '5'].includes(dataHR.state) ? true : false;

              return {
                num: bCommodity.id,
                codArticle: bCommodity.logi_product_ItemCode,
                article: bCommodity.ItemName,
                packs: bCommodity.package_quantity,
                unities: bCommodity.unit_quantity,
                entry: bCommodity.quantity_load,
                returns: bCommodity.quantity_returned,
                /* physic_quantity_returned: canUpdate ? (
                  <AllowedGuard
                    permission={
                      ConstantPermissions.PROG_SHEET_DISTRIBUTIONS_LIQUIDATION_COMMODITY_SAVE
                    }
                    component={bCommodity.physic_quantity_returned}
                  >
                    <TextField
                      name="physic_quantity_returned"
                      value={bCommodity.physic_quantity_returned || ''}
                      onChange={(e) =>
                        handleChangeRow('physic_quantity_returned', e.target.value, bCommodity.id)
                      }
                      onKeyUp={(e) => {
                        if (e.target.value > bCommodity.quantity_load + 5) {
                          handleChangeRow(
                            'physic_quantity_returned',
                            bCommodity.quantity_load + 5,
                            bCommodity.id
                          );
                        }
                      }}
                      margin="normal"
                      size="small"
                      type="number"
                      inputProps={{
                        max: bCommodity.quantity_load + 5,
                        min: 0
                      }}
                      InputProps={{ className: classes.input }}
                      fullWidth
                    />
                  </AllowedGuard>
                ) : (
                  bCommodity.physic_quantity_returned || 0
                ), */
                diferents: canUpdate ? (
                  <AllowedGuard
                    permission={
                      ConstantPermissions.PROG_SHEET_DISTRIBUTIONS_LIQUIDATION_COMMODITY_SAVE
                    }
                    component={bCommodity.difference}
                  >
                    <TextField
                      name="difference"
                      value={bCommodity.difference === null ? '' : bCommodity.difference}
                      onChange={(e) => handleChangeRow('difference', e.target.value, bCommodity.id)}
                      onKeyUp={(e) => {
                        if (e.target.value > bCommodity.quantity_load + 5) {
                          handleChangeRow(
                            'difference',
                            bCommodity.quantity_load + 5,
                            bCommodity.id
                          );
                        }
                      }}
                      margin="normal"
                      size="small"
                      type="number"
                      inputProps={{
                        max: bCommodity.quantity_load + 5
                      }}
                      InputProps={{ className: classes.input }}
                      fullWidth
                    />
                  </AllowedGuard>
                ) : (
                  bCommodity.difference || 0
                ),
                difference_amount: currency(bCommodity.difference_amount) || 0,
                actions: ''
              };
            })}
          />
        </CardBody>
      </Card>
    </>
  );
});
